export const ROLES = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_PAYMENT_CONFIGURATIONS_VIEW: 'ROLE_PAYMENT_CONFIGURATIONS_VIEW',
  ROLE_PAYMENT_CONFIGURATIONS_EDIT: 'ROLE_PAYMENT_CONFIGURATIONS_EDIT',
  ROLE_CHANNEL_HASH_VIEW: 'ROLE_CHANNEL_HASH_VIEW',
  ROLE_CHANNEL_HASH_EDIT: 'ROLE_CHANNEL_HASH_EDIT',
  ROLE_TOGGLZ_VIEW: 'ROLE_TOGGLZ_VIEW',
  ROLE_TOGGLZ_EDIT: 'ROLE_TOGGLZ_EDIT',
  ROLE_RULE_VIEW: 'ROLE_RULE_VIEW',
  ROLE_RULE_EDIT: 'ROLE_RULE_EDIT',
  ROLE_SOURCE_VIEW: 'ROLE_SOURCE_VIEW',
  ROLE_SOURCE_EDIT: 'ROLE_SOURCE_EDIT',
  ROLE_DYNAMIC_RULE_VIEW: 'ROLE_DYNAMIC_RULE_VIEW',
  ROLE_DYNAMIC_RULE_EDIT: 'ROLE_DYNAMIC_RULE_EDIT',
  ROLE_PAYOPT_VIEW: 'ROLE_PAYOPT_VIEW',
  ROLE_PAYOPT_EDIT: 'ROLE_PAYOPT_EDIT',
  ROLE_CLIENT: 'ROLE_CLIENT',
  ROLE_MCC_VIEW: 'ROLE_MCC_VIEW',
  ROLE_MCC_EDIT: 'ROLE_MCC_EDIT',
  ROLE_LOYALTY_VIEW: 'ROLE_LOYALTY_VIEW',
  ROLE_LOYALTY_EDIT: 'ROLE_LOYALTY_EDIT',
  ROLE_CURRENCY_DETAILS_VIEW: 'ROLE_CURRENCY_DETAILS_VIEW',
  ROLE_CURRENCY_DETAILS_EDIT: 'ROLE_CURRENCY_DETAILS_EDIT',
  ROLE_ORDER_SEARCH_VIEW: 'ROLE_ORDER_SEARCH_VIEW',
  ROLE_ERROR_CONFIG_VIEW: 'ROLE_ERROR_CONFIG_VIEW',
  ROLE_ERROR_CONFIG_EDIT: 'ROLE_ERROR_CONFIG_EDIT',
  ROLE_MONITORING_MAIN_DASHBOARD: 'ROLE_MONITORING_MAIN_DASHBOARD',
  ROLE_MONITORING_LOG_EXPLORER: 'ROLE_MONITORING_LOG_EXPLORER',
  ROLE_MONITORING_LOAD_BALANCER_DASHBOARD:
    'ROLE_MONITORING_LOAD_BALANCER_DASHBOARD',
  ROLE_MONITORING_LOAD_BALANCER_LOGS: 'ROLE_MONITORING_LOAD_BALANCER_LOGS',
  ROLE_MONITORING_HEALTH_CHECK: 'ROLE_MONITORING_HEALTH_CHECK',
  ROLE_MONITORING_GALAXY_TRANSACTIONS: 'ROLE_MONITORING_GALAXY_TRANSACTIONS',
  ROLE_MONITORING_CASHIER_TRANSACTIONS: 'ROLE_MONITORING_CASHIER_TRANSACTIONS',
  ROLE_CONTEXTUAL_MESSAGES_VIEW: 'ROLE_CONTEXTUAL_MESSAGES_VIEW',
  ROLE_CONTEXTUAL_MESSAGES_EDIT: 'ROLE_CONTEXTUAL_MESSAGES_EDIT',
  ROLE_MAINTENANCE_RULE_VIEW: 'ROLE_MAINTENANCE_RULE_VIEW',
  ROLE_MAINTENANCE_RULE_EDIT: 'ROLE_MAINTENANCE_RULE_EDIT',
  ROLE_METHOD_MATRIX_VIEW: 'ROLE_METHOD_MATRIX_VIEW',
  ROLE_SMART_ALERTS: 'ROLE_SMART_ALERTS',

  // Legacy Payment Options
  ROLE_LEGACY_ADMIN: 'ROLE_LEGACY_ADMIN',
  ROLE_LEGACY_MAINTENANCE_SCHEDULE_VIEW:
    'ROLE_LEGACY_MAINTENANCE_SCHEDULE_VIEW',
  ROLE_LEGACY_MAINTENANCE_SCHEDULE_EDIT:
    'ROLE_LEGACY_MAINTENANCE_SCHEDULE_EDIT',

  // Legacy CONTEXTUAL MESSAGES
  ROLE_LEGACY_CONTEXTUAL_MESSAGES_VIEW: 'ROLE_LEGACY_CONTEXTUAL_MESSAGES_VIEW',
  ROLE_LEGACY_CONTEXTUAL_MESSAGES_EDIT: 'ROLE_LEGACY_CONTEXTUAL_MESSAGES_EDIT',
  ROLE_UPLOADS: 'ROLE_UPLOADS',
  ROLE_VIEW_CONFIG_MODULE: 'ROLE_VIEW_CONFIG_MODULE',
  ROLE_EDIT_CONFIG_MODULE: 'ROLE_EDIT_CONFIG_MODULE',
  ROLE_ROLLBACK_CONFIG_MODULE: 'ROLE_ROLLBACK_CONFIG_MODULE',
  ROLE_CACHE_RELOAD_MODULE: 'ROLE_CACHE_RELOAD_MODULE',

  // User Management Groups
  ROLE_GROUP_VIEW: 'ROLE_GROUP_VIEW',
  ROLE_GROUP_EDIT: 'ROLE_GROUP_EDIT',
};

export const permissionRoleMapping = {
  // Payment Config
  canViewPaymentConfig: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_PAYMENT_CONFIGURATIONS_VIEW,
    ROLES.ROLE_PAYMENT_CONFIGURATIONS_EDIT,
    ROLES.ROLE_CURRENCY_DETAILS_EDIT,
    ROLES.ROLE_CURRENCY_DETAILS_VIEW,
  ],
  canCreatePaymentConfig: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_PAYMENT_CONFIGURATIONS_EDIT,
  ],
  canUpdatePaymentConfig: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_PAYMENT_CONFIGURATIONS_EDIT,
  ],
  canDeletePaymentConfig: [ROLES.ROLE_ADMIN],
  canRefreshPaymentConfigCache: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_PAYMENT_CONFIGURATIONS_EDIT,
  ],

  // Togglz
  canViewTogglz: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_TOGGLZ_VIEW,
    ROLES.ROLE_TOGGLZ_EDIT
  ],
  canCreateTogglz: [ROLES.ROLE_ADMIN, ROLES.ROLE_TOGGLZ_EDIT],
  canEnableDisableTogglz: [ROLES.ROLE_ADMIN, ROLES.ROLE_TOGGLZ_EDIT],
  canDeleteTogglz: [ROLES.ROLE_ADMIN],

  // Channel Hashes
  canViewChannelHashes: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CHANNEL_HASH_VIEW,
    ROLES.ROLE_CHANNEL_HASH_EDIT,
    ROLES.ROLE_TOGGLZ_EDIT
  ],
  canCreateChannelHashes: [ROLES.ROLE_ADMIN, ROLES.ROLE_CHANNEL_HASH_EDIT],
  canUpdateChannelHashes: [ROLES.ROLE_ADMIN, ROLES.ROLE_CHANNEL_HASH_EDIT],
  canDeleteChannelHashes: [ROLES.ROLE_ADMIN],
  canRefreshChannelHashesCache: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CHANNEL_HASH_EDIT,
  ],

  // User Management: Permissions [START]

  // Users
  canViewUserManagementUser: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_USER_VIEW,
    ROLES.ROLE_USER_EDIT,
  ],
  canCreateUserManagementUser: [ROLES.ROLE_ADMIN, ROLES.ROLE_USER_EDIT],
  canUpdateUserManagementUser: [ROLES.ROLE_ADMIN, ROLES.ROLE_USER_EDIT],
  canDeleteUserManagementUser: [ROLES.ROLE_ADMIN],

  // Roles
  canViewUserManagementRole: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_USER_ROLE_VIEW,
    ROLES.ROLE_USER_ROLE_EDIT,
  ],
  canCreateUserManagementRole: [ROLES.ROLE_ADMIN, ROLES.ROLE_USER_ROLE_EDIT],

  // Groups
  canViewUserManagementGroup: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_GROUP_VIEW,
    ROLES.ROLE_GROUP_EDIT,
  ],
  canCreateUserManagementGroup: [ROLES.ROLE_ADMIN, ROLES.ROLE_GROUP_EDIT],
  canUpdateUserManagementGroup: [ROLES.ROLE_ADMIN, ROLES.ROLE_GROUP_EDIT],
  canDeleteUserManagementGroup: [ROLES.ROLE_ADMIN],

  // User Management: Permissions [END]

  // Payment Orchestration Rules
  canViewPaymentOrchRule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_RULE_VIEW,
    ROLES.ROLE_RULE_EDIT,
  ],
  canCreatePaymentOrchRule: [ROLES.ROLE_ADMIN, ROLES.ROLE_RULE_EDIT],
  canUpdatePaymentOrchRule: [ROLES.ROLE_ADMIN, ROLES.ROLE_RULE_EDIT],
  canDeletePaymentOrchRule: [ROLES.ROLE_ADMIN],
  canForceDisablePaymentOrchRule: [ROLES.ROLE_ADMIN, ROLES.ROLE_RULE_EDIT],

  // Payment Orchestration Sources
  canViewPaymentOrchSources: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_SOURCE_VIEW,
    ROLES.ROLE_SOURCE_EDIT,
  ],
  canCreatePaymentOrchSource: [ROLES.ROLE_ADMIN, ROLES.ROLE_SOURCE_EDIT],
  canUpdatePaymentOrchSource: [ROLES.ROLE_ADMIN, ROLES.ROLE_SOURCE_EDIT],
  canDeletePaymentOrchSource: [ROLES.ROLE_ADMIN],
  canRefreshPaymentOrchSourceCache: [ROLES.ROLE_ADMIN, ROLES.ROLE_SOURCE_EDIT],

  // Payment Orchestration - Dynamic Rules
  canViewPaymentOrchDynamicRule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_DYNAMIC_RULE_EDIT,
    ROLES.ROLE_DYNAMIC_RULE_VIEW,
  ],
  canCreatePaymentOrchDynamicRule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_DYNAMIC_RULE_EDIT,
  ],
  canUpdatePaymentOrchDynamicRule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_DYNAMIC_RULE_EDIT,
  ],
  canDeletePaymentOrchDynamicRule: [ROLES.ROLE_ADMIN],

  // MCC Conversion
  canViewMCCRates: [ROLES.ROLE_ADMIN, ROLES.ROLE_MCC_EDIT, ROLES.ROLE_MCC_VIEW],
  canUpdateMCCRates: [ROLES.ROLE_ADMIN, ROLES.ROLE_MCC_EDIT],

  // Loyalty Rates Conversion
  canViewLPRates: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_LOYALTY_EDIT,
    ROLES.ROLE_LOYALTY_VIEW,
  ],
  canUpdateLPRates: [ROLES.ROLE_ADMIN, ROLES.ROLE_LOYALTY_EDIT],

  // Loyalty Config
  canViewLPConfig: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_LOYALTY_EDIT,
    ROLES.ROLE_LOYALTY_VIEW,
  ],
  canUpdateLPConfig: [ROLES.ROLE_ADMIN, ROLES.ROLE_LOYALTY_EDIT],

  // Currency Details
  canViewCurrencyDetails: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CURRENCY_DETAILS_VIEW,
    ROLES.ROLE_CURRENCY_DETAILS_EDIT,
  ],
  canCreateCurrencyDetails: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CURRENCY_DETAILS_EDIT,
  ],
  canUpdateCurrencyDetails: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CURRENCY_DETAILS_EDIT,
  ],
  canDeleteCurrencyDetails: [ROLES.ROLE_ADMIN],
  canRefreshCurrencyDetailsCache: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CURRENCY_DETAILS_EDIT,
  ],

  // Search Order
  canSearchOrder: [ROLES.ROLE_ADMIN, ROLES.ROLE_ORDER_SEARCH_VIEW],

  // Error Config
  canViewErrorConfig: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_ERROR_CONFIG_VIEW,
    ROLES.ROLE_ERROR_CONFIG_EDIT,
  ],
  canCreateErrorConfig: [ROLES.ROLE_ADMIN, ROLES.ROLE_ERROR_CONFIG_EDIT],
  canUpdateErrorConfig: [ROLES.ROLE_ADMIN, ROLES.ROLE_ERROR_CONFIG_EDIT],
  canDeleteErrorConfig: [ROLES.ROLE_ADMIN],
  canRefreshErrorConfigCache: [ROLES.ROLE_ADMIN, ROLES.ROLE_ERROR_CONFIG_EDIT],

  // Maintenance Rule
  canViewMaintenanceRule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_MAINTENANCE_RULE_VIEW,
    ROLES.ROLE_MAINTENANCE_RULE_EDIT,
  ],
  canCreateMaintenanceRule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_MAINTENANCE_RULE_EDIT,
  ],
  canDeleteMaintenanceRule: [ROLES.ROLE_ADMIN],

  // Method Matrix
  canViewMethodMatrix: [ROLES.ROLE_ADMIN, ROLES.ROLE_METHOD_MATRIX_VIEW],

  // Payment Options
  canViewPaymentOptions: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_PAYOPT_VIEW,
    ROLES.ROLE_PAYOPT_EDIT,
  ],
  canEditPaymentOptions: [ROLES.ROLE_ADMIN, ROLES.ROLE_PAYOPT_EDIT],

  // Contextual Messages
  canViewContextualMessages: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CONTEXTUAL_MESSAGES_VIEW,
    ROLES.ROLE_CONTEXTUAL_MESSAGES_EDIT,
  ],
  canEditContextualMessages: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_CONTEXTUAL_MESSAGES_EDIT,
  ],

  /** Legacy Payment Options */

  // Maintenance Schedule
  canViewLegacyMaintenanceSchedule: [
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_LEGACY_MAINTENANCE_SCHEDULE_VIEW,
  ],
  canCreateLegacyMaintenanceSchedule: [
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_LEGACY_MAINTENANCE_SCHEDULE_EDIT,
  ],
  canDeleteLegacyMaintenanceSchedule: [
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_LEGACY_MAINTENANCE_SCHEDULE_EDIT,
  ],

  /** Legacy Payment Options */

  // Contextual Messages
  canViewLegacyContextualMessages: [
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_LEGACY_CONTEXTUAL_MESSAGES_VIEW,
  ],
  canCreateLegacyContextualMessages: [
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_LEGACY_CONTEXTUAL_MESSAGES_EDIT,
  ],
  canDeleteLegacyContextualMessages: [
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_LEGACY_CONTEXTUAL_MESSAGES_EDIT,
  ],
  // Uploads
  canViewUploadTile: [ROLES.ROLE_ADMIN, ROLES.ROLE_UPLOADS],
  canViewConfigModule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_VIEW_CONFIG_MODULE,
  ],
  canEditConfigModule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_EDIT_CONFIG_MODULE,
  ],
  canRollBackConfigModule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_ROLLBACK_CONFIG_MODULE,
  ],
  canCacheReloadModule: [
    ROLES.ROLE_ADMIN,
    ROLES.ROLE_LEGACY_ADMIN,
    ROLES.ROLE_CACHE_RELOAD_MODULE,
  ],
};

export const APP_NOTIFICATION_TYPE = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  INFO_V6: 'infoV6',
  WARNING_V6: 'warningV6',
};
